import { Switch } from "@material-tailwind/react";

export function CheckedSwitch() {
  return <Switch defaultChecked />;
}
